<ng-template #loader>
  <div class="flex-1">
    <mat-progress-bar mode="indeterminate" />
  </div>
</ng-template>

<div
  *ngIf="note$ | async as note; else loader"
  class="relative flex min-h-0 flex-auto flex-col"
>
  <div
    *ngIf="(isSynchronised$ | async) === false"
    class="sync-notes layout-padding flex flex-col items-center justify-center gap-4"
  >
    <mat-icon>error_outline</mat-icon>
    <strong>Note Out Of Sync</strong>
    <p>
      Note currently being edited in another tab. Please sync to view the most
      recent changes.
    </p>
    <div>
      <button mat-stroked-button (click)="updateNote$.next()">
        <mat-icon>sync</mat-icon>
        Sync Note
      </button>
    </div>
  </div>

  <div
    class="min-h-0 flex-auto overflow-y-auto"
    [ngClass]="{
      disabled: (disabled$ | async) || (isSynchronised$ | async) === false
    }"
  >
    <pr-content-editor
      [disabled]="(disabled$ | async) || (isSynchronised$ | async) === false"
      [formControl]="noteControl"
      [extensions]="extensions"
    />
  </div>

  <div class="toolbar-container flex shrink-0 items-center justify-between">
    <div class="flex gap-2">
      <ng-container *ngIf="displayNoteHistory$ | ngrxPush">
        <ng-container *ngIf="allNotes$ | async as notes">
          <ng-container *ngIf="notes.length">
            <button
              mat-icon-button
              matTooltip="View Clinical Note History"
              (click)="openNotesHistory()"
            >
              <mat-icon>history</mat-icon>
            </button>
          </ng-container>
        </ng-container>
      </ng-container>
      <button
        *ngIf="canLockNote$ | ngrxPush"
        mat-icon-button
        [matTooltip]="lockNoteTooltip$ | async"
        (click)="toggleLock()"
      >
        <mat-icon>{{ note.immutable ? 'lock' : 'lock_open' }}</mat-icon>
      </button>
    </div>

    <div class="flex items-start gap-4">
      <pr-practitioner-selector
        *ngIf="displayStafferSelector$ | ngrxPush"
        label="Recording As"
        [staffer]="staffer$ | ngrxPush"
        (stafferSelected)="staffer$.next($event)"
      />

      <pr-scribe-launcher
        [patient]="(patient$ | async) ?? undefined"
        [staffer]="(staffer$ | async) ?? undefined"
        [recordDate]="(recordDate$ | async) ?? undefined"
        (noteCreated)="addHeidiNote($event)"
      />
    </div>
  </div>
</div>
